import { Component } from '@angular/core';
import { BankBaseTabPageComponent } from '../bank-base-tab-page.component';

@Component({
  selector: 'positive-pay-setup',
  standalone: true,
  imports: [],
  templateUrl: './positive-pay-setup.component.html',
  styleUrl: './positive-pay-setup.component.less'
})
export class PositivePaySetupComponent extends BankBaseTabPageComponent {
}
